const artistOverlayTriggers = document.querySelectorAll(`.js-artist-card-trigger`);

if(artistOverlayTriggers) {

    const artistOverlays = document.querySelectorAll(`.js-artist-overlay`);

    function triggerOverlay(index) {
        let activeOverlay = artistOverlays[index];
        let closeButton = activeOverlay.querySelector(`.js-close-overlay`);
        body.classList.add(`stop-scrolling`);
        activeOverlay.classList.add(`is-active`);
        

        closeButton.addEventListener(`click`, function() {
            body.classList.remove(`stop-scrolling`);
            activeOverlay.classList.remove(`is-active`);
        });
    }

    for (let i = 0; i < artistOverlayTriggers.length; i++) {
        artistOverlayTriggers[i].addEventListener(`click`, function() {
            triggerOverlay(i);
        });
    }
    
}